import {i18n} from "../../domain/i18n.js";
import {doNothing} from "../../utils/functional-utils.js";
import { BaseComponent } from '../../base.component.js';
import { appContext } from '../../badge2.context.js';
import { ResponsivenessService } from '../../domain/responsiveness.service.js';

/**
 * @typedef {RenderableProps} _AbSeal_Props
 * @property {'xs'|'sm'|'md'} offset
 * @property {boolean} [offsetBottom = false]
 * @property {'normal'|'close'} [display = 'normal']
 * @property {function()} [onClick]
 */

export class AbSeal extends BaseComponent {

  /** @type {ResponsivenessService} */
  _responsivenessService;

  /** @type {AbTooltip} */
  _tooltip;

  constructor() {
    super();
    this._responsivenessService = appContext.obtain(ResponsivenessService);
  }

  setTooltip(tooltip) {
    if (tooltip) {
      this._tooltip = tooltip;
      this._tooltip.setTarget(this.base);
    } else if (this._tooltip) {
      this._tooltip.hide();
    }
  }

  render({ display, offset, offsetBottom, onClick }, {}, { txt, imgGlobal, zIndex, composition }) {
    const imageSrc = composition ? composition.parts.aubySeal.imageSrc : false;

    let onClickFn = () => (onClick || doNothing)();
    let onMouseEnterFn = doNothing;
    let onMouseLeaveFn = doNothing;
    if (composition.badgeType.platform === 'desktop') {
      onMouseEnterFn = () => this._tooltip ? this._tooltip.show() : doNothing();
      onMouseLeaveFn = () => this._tooltip ? setTimeout(() => this._tooltip.hide({ delayWhileHovering: true }), 500) : doNothing();
    } else {
      onClickFn = () => {
        if (onClick) {
          onClick();
        }
        if (this._tooltip) {
          if (this._tooltip.shown) {
            this._tooltip.hide();
          } else {
            this._tooltip.show();
            this._responsivenessService.onScrollAway(() => this._tooltip.hide(), true);
          }
        }
      }
    }

    // noinspection CheckTagEmptyBody
    const src = display === 'close' ? imgGlobal('close-icon-white.svg') : (imgGlobal(imageSrc || 'authorized-by-badge.svg'));
    return (
      <div className={`ab-seal ab-offset-${offset} ${offsetBottom ? `ab-offset-bottom-${offset}` : ''} ab-display-${display}`} style={{ zIndex: zIndex + 100 }}>
        <img
          className={`ab-seal-image ${onClick ? 'ab-clickable' : ''}`}
          src={src}
          alt={txt(i18n.alt.authorizedBySeal)}
          onClick={onClickFn}
          onMouseEnter={onMouseEnterFn}
          onMouseLeave={onMouseLeaveFn}
          onError={() => this.badgeService.notifyImageError(src)}
        />
      </div >
    );
  }

}
